// extracted by mini-css-extract-plugin
export default {"products":"it-z","card":"jt-z","oosMessaging":"kt-z"};